RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _, moment) {
    'use strict';


    function formatFollowerBand(count) {
        return RivalIQ.formatter.formatAbbreviated(count, null, {
            trailingZeros: false
        });
    }

    const SHOW_ALL_ID = 'ShowAllFollowerCounts';
    const FollowerBandFilter = RivalIQ.views.ItemView.mixin({
        template: '#followerBandFilterTemplate',

        attributes: {
            style: 'width: 100%;'
        },

        behaviors: {
            DropdownSelector: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        serializeData: function () {
            const me = this;

            let items = [{
                id: SHOW_ALL_ID,
                name: 'All'
            }];

            items = items.concat(_.map(RivalIQ.apps.Discovery.data.followerCountBands, function (band) {
                let name;
                if (band.high) {
                    name = `${formatFollowerBand(band.low)} - ${formatFollowerBand(band.high)}`;
                } else {
                    name = `${formatFollowerBand(band.low)}+`;
                }
                return {
                    id: band.id,
                    name: name
                };
            }));

            return {
                selectableItems: items,
                highlighted: me.getProp('followerCountLow') || me.getProp('followerCountHigh')
            };
        },

        defaultSelector: function () {
            const me = this;

            let selectedItemId;

            const low = me.getProp('followerCountLow');
            const high = me.getProp('followerCountHigh');

            if (low || high) {
                const targetBand = {};
                if (low) {
                    targetBand.low = low;
                }
                if (high) {
                    targetBand.high = high;
                }

                const selectedItem = _.find(RivalIQ.apps.Discovery.data.followerCountBands, targetBand);

                selectedItemId = _.get(selectedItem, 'id');
            }

            selectedItemId = selectedItemId || SHOW_ALL_ID;

            return `[data-item-id="${selectedItemId}"]`;
        },

        onSelectDropdown: function (data) {
            const me = this;

            let newBandId = data.itemId;
            if (newBandId === SHOW_ALL_ID) {
                newBandId = null;
            }

            const newBand = _.find(RivalIQ.apps.Discovery.data.followerCountBands, {
                id: newBandId
            });
            let low;
            let high;
            if (newBand) {
                low = newBand.low;
                high = newBand.high;
            }

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DiscoveryUsedFollowerCountFilter, {
                channel: me.getProp('channel'),
                followerCountLow: low,
                followerCountHigh: high
            });

            me.dashboardModel.setProps({
                followerCountLow: low,
                followerCountHigh: high
            });
        }
    });

    function makeClearedFilterProps() {
        return _.reduce(App.enums.filterableDimensionPropKeys, function (memo, filterDimensionPropKey) {
            memo[filterDimensionPropKey] = null;
            return memo;
        }, {});
    }

    const SearchTypeDropdown = Marionette.ItemView.mixin({
        template: '#adNavToolbarSelectorTemplate',

        behaviors: {
            DropdownSelector: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        defaultSelector: function () {
            const me = this;
            const selectedItem = me.dashboardModel.getProp('searchType') || 'recent';
            return `[data-item-id="${selectedItem}"]`;
        },

        serializeData: function () {
            return {
                label: 'Search by',
                selectableItems: App.enums.searchTypeOptions,
                highlighted: false
            };
        },

        onSelectDropdown: function (data) {
            const me = this;

            const oldSearchType = me.getProp('searchType');

            const newSearchType = data.itemId.toString();
            let previousSearchTypeOption = _.find(App.enums.searchTypeOptions, {
                id: oldSearchType
            });

            if (!previousSearchTypeOption) {
                previousSearchTypeOption = _.find(App.enums.searchTypeOptions, {
                    id: App.enums.searchTypeOptions.RECENT
                });
            }

            let currentSearchTypeOption = _.find(App.enums.searchTypeOptions, {
                id: newSearchType
            });

            if (!currentSearchTypeOption) {
                currentSearchTypeOption = _.find(App.enums.searchTypeOptions, {
                    id: App.enums.searchTypeOptions.RECENT
                });
                me.dashboardModel.setProps({
                    searchType: App.enums.searchTypeOptions.RECENT
                });
            } else {
                me.dashboardModel.setProps({
                    searchType: newSearchType
                });
            }

            if (!_.isUndefined(previousSearchTypeOption) && !_.isUndefined(currentSearchTypeOption)) {
                // handle differently if we're going from a hashtag search -> profile search, or vice versa
                if ((previousSearchTypeOption.hashtagSearch && (newSearchType === App.enums.searchTypes.PROFILE)) ||
                ((oldSearchType === App.enums.searchTypes.PROFILE) && currentSearchTypeOption.hashtagSearch)) {
                    me._parentLoadingView.clearSearch();
                }
            }
        }
    });


    views.SearchBar = RivalIQ.views.LayoutView.mixin({
        template: '#discoverySearchBarTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            followerCountBands: '.follower-count-bands',
            filterPills: '.x-filter-pills',
            searchTypeSelector: '.search-type-selector'
        },

        ui: {
            searchInput: 'input',
            searchBtn: '.x-search',
            searchResultsSummary: '.search-results-summary'
        },

        events: {
            'keypress @ui.searchInput': 'onKeyDown',
            'click @ui.searchBtn': 'onSearch',
            'click .x-clear': 'clearSearch'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        onKeyDown: function (e) {
            const me = this;

            if (e.which === 13) {
                e.preventDefault();
                me.onSearch();
            }
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();

            const metricAttrs = [
                {
                    dataSource: 'discovery',
                    dimensions: ['channel'],
                    property: 'num_posts'
                },
                {
                    dataSource: 'discovery',
                    dimensions: ['channel'],
                    property: 'time_span_hours'
                }
            ];

            const metrics = RivalIQ.metric.build(props, metricAttrs);

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            me.hideResultsSummary();

            const deferred = new $.Deferred();
            collection.fetch()
                .then(function (results) {
                    me.numPostsMetric = results.at(0);
                    me.timeSpanHoursMetric = results.at(1);
                    me.omitResultsSummary = false;
                }).fail(function () {
                    me.omitResultsSummary = true;
                }).always(deferred.resolve);

            return deferred;
        },

        onRender: function () {
            const me = this;

            // Sadly we no longer get follower count for Instagram.
            if (me.getProp('channel') === RivalIQ.enums.channels.TWITTER) {
                me.followerCountBands.show(new FollowerBandFilter({
                    dashboardModel: me.dashboardModel
                }));
            }

            me.filterPills.show(new App.views.FilterPills({
                dashboardModel: me.dashboardModel
            }));
        },

        onRenderLoaded: function () {
            const me = this;

            me.showResultsSummary();
            if (me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) {
                me.showSearchTypeSelector();
            }
        },

        serializeData: function () {
            const me = this;

            return _.defaults({}, me.dashboardModel.getProps(), {
                searchTerm: ''
            });
        },

        _executeSearch: function (searchTerm) {
            const me = this;

            me.setProps(_.extend(makeClearedFilterProps(), {
                searchTerm: searchTerm,
                searchType: me.getProp('searchType')
            }));
            me.filterPills.reset();

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DiscoverySetSearchTerm, {
                channel: me.getProp('channel'),
                searchTerm: searchTerm,
                searchType: me.getProp('searchType')
            });
        },

        onSearch: function () {
            const me = this;

            const searchTerm = me.ui.searchInput.val().trim();
            me._executeSearch(searchTerm);
        },

        clearSearch: function () {
            const me = this;
            const url = RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(RivalIQ.enums.curation.DISCOVERY, {
                channel: me.getProp('channel'),
                searchType: me.getProp('searchType')
            });
            RivalIQ.execute('history:navigate', url, {
                trigger: true
            });
        },

        hideResultsSummary: function () {
            const me = this;

            if (_.isFunction(me.ui.searchResultsSummary.text)) {
                me.ui.searchResultsSummary.text('');
            }
        },

        showResultsSummary: function () {
            const me = this;

            if (me.isDestroyed || me.omitResultsSummary) {
                return;
            }

            const numPosts = me.numPostsMetric.getValue({
                format: false
            });
            const numPostsFormatted = me.numPostsMetric.getValue({
                format: true
            });
            const timeSpanHours = me.timeSpanHoursMetric.getValue({
                format: false
            });

            if (numPosts === 0 || timeSpanHours === 0) {
                me.ui.searchResultsSummary.text('No Results Found');
            } else {
                const postName = me.getPostName();

                let text;
                if ((me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) && (me.getProp('searchType') !== App.enums.searchTypes.PROFILE)) {
                    text = [
                        'Analyzing',
                        numPostsFormatted,
                        me.getProp('searchType'),
                        RivalIQ.formatter.numericLabel(postName, `${postName}s`, numPosts)
                    ];
                } else {
                    text = [
                        'Analyzing',
                        numPostsFormatted,
                        'recent',
                        RivalIQ.formatter.numericLabel(postName, `${postName}s`, numPosts),
                        'since about',
                        moment.duration(-timeSpanHours, 'hours').humanize(true)
                    ];
                }

                me.ui.searchResultsSummary.text(text.join(' '));
            }
        },

        showSearchTypeSelector: function () {
            const me = this;
            me.searchTypeSelector.show(new SearchTypeDropdown({
                dashboardModel: me.dashboardModel
            }));
        },

        getPostName: function () {
            const me = this;
            const channel = me.getProp('channel');
            const name = RivalIQ.data.channels.get(channel).get('postName') || 'post';
            return name;
        }
    });

}, window.moment);
